// styles
import styled from 'styled-components';

const SoFormRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  gap: 8px;

  height: 24px;

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;

  svg {
    color: var(--grey300);
    fill: var(--grey300);
    path {
      fill: var(--grey300);
    }
  }
`;

export default SoFormRowContainer;
